<template>
  <div class="specific-people-info-container">
    <div style="display: flex; align-items: center">
      <h2>Notification of your passing</h2>
    </div>

    <div class="mb-4">
      <p>We will notify the following person of your passing</p>
    </div>

    <div class="mb-4">
      <PeopleList
        :people="relations.emergencyContacts"
        :testator="testator"
        relation="EMERGENCY_CONTACT"
        :limit="2"
        :emergency-contacts="true"
      />
    </div>
  </div>
</template>

<script>
  import { formatKinship } from '../../constants/js/people.js';
  import syncCircleSvg from '@/assets/shared/sync_circle.svg';
  import Revise from '../../helpers/reviseStep';
  import PeopleList from './PeopleList.vue';

  export default {
    name: 'EmergencyContactsOverview',
    components: {
      PeopleList,
    },
    props: {
      testator: {
        type: Object,
        required: true,
      },
      relations: {
        type: Object,
        required: true,
      },
    },
    data: () => ({
      syncCircleSvg: syncCircleSvg,
    }),
    methods: {
      formatPersonKinship(kinship) {
        return formatKinship(kinship, this.testator);
      },
    },
    computed: {
      hasToReviseExecutors() {
        return Revise.step_2_internal_executor_updates_to_revise(this.testator);
      },
      omOnlyExecutor() {
        if (this.testator.bypassOmOnlyExecutor) {
          return false;
        }
        return (this.testator.enabledFeatures || []).includes(
          'om_only_executor'
        );
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '../../constants/styles/people-overview-info-blocks.scss';

  .revise-notice {
    // background color in global.scss because of IE issue
    color: white;
    border-radius: 13px;
    padding: 1px 8px;
    font-size: 12px;
    display: inline-block;
    margin-bottom: 6px;
    margin-left: 12px;

    .completed-tick {
      height: 15px;
      width: 15px;
      margin-right: 2px;
      margin-top: -3px;
    }
  }

  .revise-step-content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 12px;
    font-weight: bold;
    line-height: 1.375rem;
  }
  .revise-step-content img {
    margin-top: 0 !important;
  }
</style>
